<template>
  <popup :opened="dataToShow" @close="changeToShow(false)">
    <!-- BEGIN Content modal add referent -->
    <div>
      <div class="my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32">
        <h3 class="mb-10">Modifier le fichier « {{ filename }} »</h3>

        <form class="flex flex-col items-center mb-5" autocomplete="off">
          <input-text
            name="fileName"
            libelle="Nom du fichier"
            :value="fileToEdit.name"
            @input="
              (newValue) => {
                fileToEdit.name = newValue;
              }
            "
            :error="true"
            :msg-error="((errors || [])['destination.name'] || [])[0]"
            class="lg:w-1/2 mb-5"
            :maxlength="40"
          />
        </form>

        <div class="mb-10 text-red-500 text-sm text-center">
          {{ ((errors || [])['forbidden'] || [])[0] }}
        </div>

        <div class="flex justify-center space-x-5">
          <action-button
            border-color="border-pink-600"
            text-color="text-pink-600"
            bg-color="bg-pink-100"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            libelle="Annuler"
            :uppercase="true"
            @clickAction="changeToShow(false)"
          />
          <action-button
            v-if="saving"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-gray-600"
            bg-color-square="bg-gray-600"
            libelle="Modifier"
            :uppercase="true"
            type-shadow="shadow-gray"
          />
          <action-button
            v-else
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            libelle="Modifier"
            :uppercase="true"
            type-shadow="shadow-pink"
            @clickAction="editFile()"
          />
        </div>
      </div>
    </div>
    <!-- END Content modal add referent -->
  </popup>
</template>

<script>
import Popup from './../../../components/Popup';
import ActionButton from './../../../components/ActionButton';
import InputText from './../../../components/Inputs/InputText';
import Icon from './../../../components/Icon';

export default {
  name: 'EditFilePopup',

  props: {
    dataToShow: Boolean,
    errors: Object,
    saving: {
      type: Boolean,
      required: false,
      default: false,
    },
    parentFolder: {
      type: String,
      required: false,
      default: null,
    },
    file: Object,
  },

  data() {
    return {
      fileToEdit: {
        name: '',
        extension: '',
        parent: this.parentFolder,
      },
      filename: '',
    };
  },

  components: {
    Popup,
    ActionButton,
    InputText,
    Icon,
  },

  computed: {
    //
  },

  methods: {
    changeToShow(val) {
      this.$emit('showChange', val);
    },

    editFile() {
      this.$emit('editFile', this.fileToEdit);
    },
  },

  watch: {
    dataToShow: function () {
      if (this.file.name) {
        this.fileToEdit = {
          name: this.file.name.substring(0, this.file.name.lastIndexOf('.')),
          extension: this.file.name.substring(this.file.name.lastIndexOf('.')),
          parent: this.parentFolder,
        };
        this.filename = this.fileToEdit.name;
      }
    },
  },
};
</script>
